module.exports = __webpack_public_path__ + "Flaticon.0e2f3c5e6352689c2666.ttf";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/metronic/src/vendors/flaticon/fonts/Flaticon.ttf
// module id = ../../../../../src/assets/metronic/src/vendors/flaticon/fonts/Flaticon.ttf
// module chunks = styles